<div class="carousel">
    <ngb-carousel>
        <ng-template ngbSlide *ngFor="let item of subheaderlist">
            <div class="carousel-inner">
                <qloc-theme-subheader-overview [headline]="item.title" [text]="item.text" [overview]="item.overview" [link]="item.link" [image]="item.image" [simage]="item.image2" [html]="item.html"></qloc-theme-subheader-overview>
            </div>
        </ng-template>
    </ngb-carousel>
</div>